import request from '../request';

let cookiesAccepted = sessionStorage.getItem('cookiesAccepted');

if (cookiesAccepted === 'true') {
  cookiesAccepted = true;
} else {
  cookiesAccepted = false;
}

let cookieMessageVisible = sessionStorage.getItem('cookieMessageVisible');

if (cookieMessageVisible === 'true') {
  cookieMessageVisible = true;
} else {
  cookieMessageVisible = false;
}

export default {
  namespaced: true,
  state: {
    isVisible: cookieMessageVisible,
    disclaimer: '',
    cookiesAccepted,
  },
  mutations: {
    set(state, msg) {
      state.disclaimer = msg;
    },
    accept(state) {
      state.cookiesAccepted = true;
      sessionStorage.setItem('cookiesAccepted', true);
    },
    dontAccept(state) {
      state.cookiesAccepted = false;
      sessionStorage.setItem('cookiesAccepted', false);
    },
    setVisible(state, v) {
      state.isVisible = v;
      sessionStorage.setItem('cookieMessageVisible', v);
    },
  },
  actions: {
    get(context) {
      return new Promise((resolve, reject) => {
        const { app } = context.rootState;
        const url = `${app.API_URL}${context.rootState.language}/${app.endpoints.STATIC_CONTENT}`;
        const type = 'GET';
        request.make(
          {
            url,
            type,
          },
          (reqErr, res) => {
            if (res.status === 200 && typeof res.body.data.cookie_warning !== 'undefined') {
              context.commit('set', res.body.data.cookie_warning);
              resolve();
            }
            reject();
          }
        );
      });
    },
    accept(context) {
      context.commit('accept');
      context.commit('setVisible', false);
    },
    dontAccept(context) {
      context.commit('dontAccept');
      context.commit('setVisible', false);
    },
    setVisible(context, v) {
      context.commit('setVisible', v);
    },
  },
};
